import React from 'react';
import { Box } from '@styleseat/ui';
import { HeaderText } from '../../ui';

export const ReferralLandingLoginHeader = () => (
  <Box paddingY={20} testID="referral_recipient_login_header">
    <HeaderText level={4} textAlign="center">
      {'You’ve been given 15% off (up to $50) when you discover & book a new pro on StyleSeat '}
    </HeaderText>
    <Box paddingTop={12} />
    <HeaderText level={4} textAlign="center">
      {'Sign up or log in to receive reward! '}
    </HeaderText>
  </Box>
);
